import React, { useState } from "react";
import { Oval } from "../../assets/imagesPath";
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessForm } from "../../redux/AuthSlice";

const BusinessFormation = () => {

  const navigate = useNavigate();
  const [needHelp, setNeedHelp] = useState(false);
  const [needInfo, setNeedInfo] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((data) => data?.auth);
  const formData = auth?.businessDetailForm;
  const onSubmit = () => {
    const data = {
      businessFormation: {
        needHelp: needHelp,
        needInfo: needInfo,
      },
    };
  
    dispatch(updateBusinessForm(data));
    navigate(PATHS.additionalDetails);
  };

  return (
    <div className="w-full mb-16">
      {/* <div className="bg-[#F2F2F282] text-center py-40">
        <span className="bg-blue-200 text-black text-[1.2rem] px-6 py-2 rounded-full font-semibold uppercase">
          Contact
        </span>
        <h1 className="text-[3.6rem] font-bold mt-3 smallScreens:text-[3rem]">Business Formation Decision</h1>
      </div> */}

      <div className="mx-auto text-center mb-10 space-x-4 space-y-4 mt-40 tabsBtn">
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.basicInfo)}
        >
          Basic Infomation
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessDetails)}
        >
          Business Details
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.servicesNeeded)}
        >
          Services Needed
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.clientScreening)}
        >
          Client Screening Questions
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessFormation)}
        >
          Business Formation Decision
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.additionalDetails)}
        >
          Additional Details
        </button>
      </div>

      <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
        <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-20 relative">
          {/* <div className="text-[2.4rem] text-[#121212] text-center mb-20 font-extrabold">Business Formation Decision</div> */}
          <div className="space-y-12">
            <div className='mt-10'>
              <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium">
                If you are unsure which structure fits your needs
              </label>
              {/* <div className='relative mt-4'>
                <select
                  className='appearance-none w-full py-5 px-5 border rounded-xl focus:outline-none text-2xl font-normal text-[#757575]'
                >
                  <option value="">Choose</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="I'm Looking For One">I'm Looking For One</option>
                </select>
                <span className="absolute inset-y-0 right-5 flex items-center ">
                  <Dropdown />
                </span>
              </div> */}
            </div>
            <div className='flex'>
              <input
                id="default-checkbox1"
                type="checkbox"
                className="w-8 h-8 mt-2 bg-white border-[#9CA3AF] rounded-sm custom-checkbox"
                checked={needHelp}
                onChange={(e) => setNeedHelp(e.target.checked)}
              />
              <label htmlFor="default-checkbox1" className="ms-6 text-[1.6rem] font-medium text-[#9CA3AF] ">I need help deciding</label>
              {/* <span className='mt-2 mx-4'><img className='w-[1.4rem] h-[1.4rem]' src={info} alt="" /></span> */}
            </div>
            <div className='flex'>
              <input
                id="default-checkbox2"
                type="checkbox"
                className="w-8 h-8 mt-1 bg-white border-[#9CA3AF] rounded-sm custom-checkbox"
                checked={needInfo}
                onChange={(e) => setNeedInfo(e.target.checked)}
              />
              <label htmlFor="default-checkbox2" className="ms-6 text-[1.6rem] font-medium text-[#9CA3AF]">I know I want an LLC or S Corp.</label>
              {/* <span className='mt-2 mx-4'><img className='w-[1.4rem] h-[1.4rem]' src={info} alt="" /></span> */}
            </div>
            <div className="text-center">
              <button
                type="button"
                className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                onClick={onSubmit}
              >
                Save
              </button>
            </div>
          </div>
          <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
            <img src={Oval} alt="oval-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessFormation;